/**
 * Main Zustand Store
 */
import { create } from 'zustand';
import { createAuthSlice } from './authSlice';
import type { AppStore } from './types';

export const appStore = create<AppStore>()((set, get) => ({
  ...createAuthSlice(),

  // Override methods to use Zustand's set
  setToken: (token: string | null) => {
    set({ token, isAuthorized: !!token });
  },

  setUser: (user: any) => {
    set({ user });
  },

  setIsAuthorized: (isAuthorized: boolean) => {
    set({ isAuthorized });
  },

  reset: () => {
    set({
      token: null,
      user: null,
      isAuthorized: false,
    });
  },
}));

export type { AppStore };

